import { render, staticRenderFns } from "./SolveProcessManager.vue?vue&type=template&id=379aefd0&"
import script from "./SolveProcessManager.vue?vue&type=script&lang=ts&"
export * from "./SolveProcessManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports